import React from 'react';

// Styles & Assets
import styles from './ScoresManagement.module.css';
import { FiChevronRight } from 'react-icons/fi';

// Context
import ScoresContext from '../../../context/ScoresContext';

// Hooks
import { useContext } from 'react';

// Components
import Icon from '../../UI/Icon/Icon';

// Language
import { useTranslation } from 'react-i18next';

// Other
import { Link } from 'react-router-dom';

const ScoresManagement: React.FC = () => {

    const { t } = useTranslation();

    const { scores } = useContext(ScoresContext);

    return (
        <div className={styles.container}>
            <h1>{t('scores')}</h1>
            <div className={styles.scoresContainer}>
                {scores?.map(score =>
                    <Link key={score.id} to={score.id.toString()} state={{ score }} className={styles.linkScores}>
                        <span>{score.name}</span>
                        <Icon color='#999'><FiChevronRight /></Icon>
                    </Link>
                )}
            </div>
        </div>
    );
};

export default ScoresManagement;